import React from 'react';
import AsyncSelect from 'react-select/async';
// import {selectBoxDarkTheme} from '../../theme/darkThemes'


const selectBoxDarkTheme = {
  container: (provided) => ({
    ...provided,
    background: '#000', // Adjust background color
    margin: "1rem"
  }),
  control: (provided) => ({
    ...provided,
    background: '#000', // Adjust background color
    borderColor: '#666', // Adjust border color
  }),
  option: (provided, state) => ({
    ...provided,
    background: state.isFocused ? 'green' : '#333', // Adjust background color when focused
    color: state.isSelected ? '#fff' : '#fff', // Adjust text color when selected
    // zIndex: 100
  }),
  multiValue: (provided) => ({
    ...provided,
    background: '#555', // Adjust background color for multi-value container
    // zIndex: 100
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#ccc', // Adjust text color for multi-value label
    // zIndex: 100
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#ccc', // Adjust text color for multi-value remove icon
  }),
  input: (provided) => ({
    ...provided,
    color: '#fff', // Set the color for the input
  }),
  menu: provided => ({ ...provided, zIndex: 9999 })
};

const SearchableSelectBox = (props) => {
  return (
  <AsyncSelect
    // id="tickerSelect"
    placeholder="Select Tickers..." // Add a placeholder
    // defaultValue={props?.defaltPrimaryMetric}
    value = {props?.selectedTickers}
    isMulti = {props?.isMulti}
    menuPosition={'fixed'} 
    name="Select Tickers"
    // options={props?.tickersNames?.slice(0, 100)}
    className="basic-multi-select"
    classNamePrefix="react-select"
    cacheOptions
    styles={selectBoxDarkTheme} // Apply the dark theme styles
    defaultOptions={props?.tickersNames}
    loadOptions={props?.handleInputChange}
    onChange={props.handleSelectChange} // Capture changes in selected values
    // onInputChange={props?.handleInputChange} // Capture changes in the search input
  />
  )

}
export default SearchableSelectBox

